export default __webpack_public_path__ + "static/media/logo-symbol.1f50db40.svg";